<template>
  <div>
    <div class="site-header row">
      <div class="col-4"></div>
      <div class="col-4">
        <img src="../../assets/tassyl9-grey.png" class="top-logo mt-4">
        <div class="tagline text-center">
          <p>Connecting you to your future.</p>
        </div>
      </div>
      <div class="col-4"></div>
    </div>
    <div class="container login-div">
      <div class="row justify-content-center mt-5">
        <div class="card" style="width: 30rem;">
          <div class="card-body">
            <h2 class="card-title text-center">Confirmation Email Sent</h2>
            <p class="text-center mt-4 mb-4">Thank you for signing up. Please check your email for a link to confirm your account!</p>
            <p class="text-center text-danger">You can start your application but you won't be able to submit it until your account is confirmed.</p>
            <div class="row justify-content-center">
              <button v-on:click="proceed" class="btn col-sm-6 btn-primary log-in">Continue</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    nextPath: String
  },
  methods:{
    proceed(){
      this.$router.push(this.$store.state.afterLoginPath)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
